import React from 'react';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';

import PaginationSelect from '@components/PaginationSelect/PaginationSelect';

import './Pagination.scss';

const Pagination = ({
  bar,
  children,
  count,
  page,
  onPageChange,
}) => (
  <Paper className="pagination">
    <div className="pagination__header">
      <div className="pagination__bar">
        {bar}
      </div>
      <div className="pagination__count">
        <p>{count} items</p>
        <PaginationSelect
          count={count}
          page={page}
          onPageChange={onPageChange}
        />
      </div>
    </div>
    {children}
    <div className="pagination__footer">
      <div className="pagination__count">
        <PaginationSelect
          count={count}
          page={page}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  </Paper>
);

Pagination.propTypes = {
  bar: PropTypes.node,
  children: PropTypes.element.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

Pagination.defaultProps = {
  bar: null,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/common/components/Pagination/Pagination.js